import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import {
  CallsAnalyticsPage,
  ContactsAnalyticsPage,
  ConversationsAnalyticsPage,
  CreditUsageAnalyticsPage,
  CreditUsageSourcesPage,
  MessagesAnalyticsPage,
  PerformanceAnalyticsPage,
  ConversionsAnalyticsListPage,
  OverallAnalyticsPage,
} from 'pages/analytics/pages'
import { AnalyticsRoutes } from 'pages/analytics/route/type'
import { AnalyticsAccessLayout } from 'pages/analytics/layout/AnalyticsAccessLayout'
import { AnalyticsLayout } from 'pages/analytics/layout/AnalyticsLayout'
import { ConversionAnalyticsDetailsPage } from 'pages/analytics/pages/conversions/pages/conversionDetail/ui/ConversionAnalyticsDetailsPage'

export const AnalyticsRouter = observer(() => (
  <Routes>
    <Route element={<AnalyticsAccessLayout />}>
      <Route element={<AnalyticsLayout />}>
        <Route index element={<Navigate to={AnalyticsRoutes.overall} />} />
        <Route path={`${AnalyticsRoutes.overall}`} element={<OverallAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.conversations}`} element={<ConversationsAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.messages}`} element={<MessagesAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.calls}`} element={<CallsAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.performance}`} element={<PerformanceAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.contacts}`} element={<ContactsAnalyticsPage />} />
        <Route path={`${AnalyticsRoutes.conversions}`} element={<ConversionsAnalyticsListPage />} />
        <Route
          path={`${AnalyticsRoutes.conversions}/:id`}
          element={<ConversionAnalyticsDetailsPage />}
        />
        <Route path={`${AnalyticsRoutes.creditUsage}`}>
          <Route index element={<Navigate to={AnalyticsRoutes.all} replace />} />
          <Route path={`${AnalyticsRoutes.all}`} element={<CreditUsageAnalyticsPage />} />
          <Route path={`${AnalyticsRoutes.sources}`} element={<CreditUsageSourcesPage />} />
        </Route>
      </Route>
    </Route>
  </Routes>
))
